import { EChatType } from '@cian/chats-api';

import { CHATBOT_ID } from '../../../constants/chatbotId';
import { TOffer } from '../../../types/offer';
import { IUserInChatListSchema } from '../../../types/userData';
import { editMessageInQueue } from '../../slices/messagesQueue';
import { addNotification } from '../../slices/notifications';
// eslint-disable-next-line import/no-cycle
import { TThunkAction } from '../../types/redux/thunk';

/**
 * Проверка наличия уведомлений
 */
export const checkNotifications = (): TThunkAction<Promise<void>> => async (dispatch, getState, context) => {
  const { chatList, messagesQueue } = getState();
  const {
    custom: { messagesMap },
  } = context;

  messagesQueue.list.forEach(message => {
    if (message.isShow) {
      return;
    }

    const chat = chatList.find(c => c.chatId === message.chatId);
    const messageData = messagesMap.get(message.messageId);

    if (chat?.chatId === CHATBOT_ID || chat?.type === EChatType.Bot) {
      // при удалении надо переписать индексы и пройти по всем сообщениям
      dispatch(editMessageInQueue({ messageId: message.messageId, isShow: true }));

      return;
    }

    const offer = chat?.data?.offer;
    let imageUrl = '';
    if (offer && (offer as TOffer).photos && (offer as TOffer).photos?.length > 0) {
      imageUrl = ((offer as TOffer).photos.find(p => p.isDefault) || offer.photos[0])?.miniUrl;
    }

    if (!imageUrl) {
      const companionId = messageData?.message.message.userId;
      const companion = chat?.users?.find((user: IUserInChatListSchema) => user.userId === companionId);
      imageUrl = companion?.agentAvatarUrl || '';
    }
    if (chat) {
      dispatch(
        addNotification({
          chatId: chat.chatId,
          title: chat.description || chat.title || '',
          id: message.messageId,
          imageUrl,
          message: messageData?.message.rawMessage.text || '',
          isOffer: offer && !!offer?.formattedFullInfo,
        }),
      );
      dispatch(editMessageInQueue({ messageId: message.messageId, isShow: true }));
    }
  });
};
